export default class CollapseEntry {
  constructor(container) {
    this.$collapse = $(container);

    if (this.$collapse.length == 0) {
      return;
    }

    this.$parentContainer = $(container).parent();
    this.$header = this.$collapse.find(".collapse-entry__header");

    this.handleToggle();
    this.handleTransitionEvents();
  }

  handleTransitionEvents = () => {
    // adds overflow after element open transition
    document.addEventListener("transitionend", (e) => {
      const { propertyName, target } = e;
      if (propertyName === "max-height") {
        if (
          $(target)
            .parents(".collapse-entry")
            .hasClass("collapse-entry--open")
        ) {
          // open
          $(target).css("overflow", "visible");
        }
      }
    });

    // removes overflow when closing element
    document.addEventListener("transitionstart", (e) => {
      const { propertyName, target } = e;
      if (propertyName === "max-height") {
        if (
          !$(target)
            .parents(".collapse-entry")
            .hasClass("collapse-entry--open")
        ) {
          // close
          $(target).css("overflow", "hidden");
        }
      }
    });
  };

  handleToggle = () => {
    const { $collapse, $header, $parentContainer } = this;

    Array.from($header).forEach((el) => {
      $(el).on("click", (e) => {
        e.preventDefault();

        const parent = $(e.currentTarget).parent();

        if (!parent.hasClass("collapse-entry--open")) {
          this.closeAll();
          parent.addClass("collapse-entry--open");

          const $contentContainer = parent.find(".collapse-entry__content");

          parent.addClass("collapse-entry--open");
          $contentContainer.css(
            "max-height",
            $contentContainer.prop("scrollHeight") + 16 + "px"
          );
        } else {
          parent.removeClass("collapse-entry--open");
          $parentContainer
            .find(".collapse-entry__content")
            .css("max-height", "0");
        }
      });
    });
  };

  destroyHandle = () => {
    const { $collapse, $header, $parentContainer } = this;

    Array.from($header).forEach((el) => {
      $(el).off("click");
    });
    this.openAll();
  };

  closeAll = () => {
    const { $parentContainer } = this;

    $parentContainer
      .find(".collapse-entry")
      .removeClass("collapse-entry--open");
    $parentContainer.find(".collapse-entry__content").css("max-height", "0");
  };

  openAll = () => {
    const { $parentContainer } = this;

    // $parentContainer.find('.collapse-entry').removeClass('collapse-entry--open');
    $parentContainer
      .find(".collapse-entry__content")
      .css("max-height", "inherit");
  };
}
